export default {
  'proTech.proEquip': 'معدات الإنتاج',
  'proTech.chiselIntroduce': 'أشبيفي',
  'proTech.testingInstrument': 'أداة اختبار',
  'proTech.techProcess': 'العملية التكنولوجية'
}
